/**
 * Represents a repository for leaving share spaces.
 */
export const LeaveSpacesRepository = Symbol('LeaveSpacesRepository');
/**
 * Represents a service for leaving share spaces.
 */
export const LeaveSpacesService = Symbol.for('LeaveSpacesService');
